var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    { attrs: { placement: "bottom", width: "350", trigger: "click" } },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "邮件(1)", name: "first" } }),
          _c("el-tab-pane", { attrs: { label: "消息(2)", name: "second" } }),
          _c("el-tab-pane", { attrs: { label: "通知", name: "third" } }),
        ],
        1
      ),
      _c(
        "el-scrollbar",
        { staticStyle: { height: "300px" } },
        [
          _c("avue-notice", {
            attrs: { data: _vm.data, option: _vm.option },
            on: { "page-change": _vm.pageChange },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _c("el-badge", { attrs: { "is-dot": "" } }, [
            _c("i", { staticClass: "el-icon-bell" }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }